export default __webpack_public_path__ + "static/media/large.441ce31f.png";